import { render, staticRenderFns } from "./T1HeadScripts.vue?vue&type=template&id=15badd25&"
import script from "./T1HeadScripts.vue?vue&type=script&lang=js&"
export * from "./T1HeadScripts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports